import { SET_QUOTES, SET_POSTAL, SET_DROPOFF, SET_PICKUP, RESET_QUOTES } from '../actions/quotes';

const initialState = {}

export default function quotes(state = {}, action) {
  switch (action.type) {
    case RESET_QUOTES:
      return Object.assign({}, state, {
        quotes: {}
      })
    case SET_QUOTES:
      return Object.assign({}, state, {
        quotes: action.payload
      })
    case SET_POSTAL:
      return Object.assign({}, state, {
        postal: action.payload
      })
    case SET_DROPOFF:
      return Object.assign({}, state, {
        dropoff: action.payload,
      })
    case SET_PICKUP:
      return Object.assign({}, state, {
        pickup: action.payload
      })
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./app/javascript/components/reducers/quotes.js